<script lang="ts">
    import {recordTypes} from '../../../../constants/portaro.constants';
    import KpCover from '../../../../../record/kp-cover/KpCover.svelte';
    import {pipe} from '../../../../../svelte/utils';
    import {loc} from '../../../../../svelte/pipes';
    import KpCustomParagraph from './KpCustomParagraph.svelte';

    export let value: any; // TODO add type
    export let isSelected = false;

    $: canShowCover = !isExternal;

    $: isDocument = value?.type === recordTypes.TYPE_DOCUMENT;

    $: isExternal = value?.external;
</script>

<template>
    <div class="selectable-record-card">
        <div class="panel panel-default" class:panel-primary={isSelected}>
            <div class="panel-body">
                <div class="card-content">
                    {#if canShowCover}
                        <div class="record-cover">
                            <!-- target null to disable click on cover -->
                            <KpCover record={value} target={null} fillTo={'width'}/>
                        </div>
                    {/if}

                    {#if value?.exports?.portaroSearchItemParagraph}
                        <div class="record-info">
                            <div class="card-labels">
                                <div class="fond-label">
                                    <span class="label label-info">{pipe(value.fond, loc())}</span>
                                </div>
                                {#if !value.valid}
                                    <div>
                                        <span class="label label-danger">Nevalidní</span>
                                    </div>
                                {/if}
                            </div>
                            <div>
                                <div class="nazevZaznamu">
                                    {#if isExternal}
                                        <span>{value.name ?? ''}</span>
                                    {:else}
                                        <a href="/records/{value.id}" target="_blank" rel="noreferrer">{value.name}</a>
                                    {/if}
                                </div>

                                <div class="record-subtitle">{value.subTitle ?? ''}</div>

                                <div class="list-item-document-autor">
                                    {#if value.mainAuthors && Array.isArray(value.mainAuthors)}
                                        {#each value.mainAuthors as author, index}
                                            {#if author.id}
                                        <span>
                                            <a href="/records/{author.id}" target="_blank" rel="noreferrer">{pipe(author, loc())}</a>
                                            {#if index < (value.mainAuthors.length - 1)} - {/if}
                                        </span>
                                            {/if}
                                        {/each}
                                    {/if}
                                </div>
                                <KpCustomParagraph content={value.exports.portaroSearchItemParagraph} customClass="paragraph-template list-item-document-paragraph-template"/>
                                <div>
                                </div>
                            </div>
                        </div>
                    {:else}
                        <div class="record-info">
                            <div class="card-labels">
                                {#if !value.valid}
                                    <div>
                                        <span class="label label-danger">Nevalidní</span>
                                    </div>
                                {/if}
                            </div>
                            <div>
                                <div class="record-name">
                                    <strong>{value.name ?? ''}</strong>
                                </div>

                                {#if isDocument}
                                    <div>
                                        <div class="record-subtitle"> {value.subTitle ?? ''}</div>
                                        <span>{value?.isbn?.value ?? ''}</span>
                                        <div class="list-item-document-autor">
                                            {#if value.mainAuthors && Array.isArray(value.mainAuthors)}
                                                {#each value.mainAuthors as author, index}
                                                    {#if author.id}
                                                <span>
                                                    {pipe(author, loc())}
                                                    {#if index < (value.mainAuthors.length - 1)} - {/if}
                                                </span>
                                                    {/if}
                                                {/each}
                                            {/if}
                                        </div>
                                    </div>
                                {/if}
                            </div>
                        </div>
                    {/if}
                </div>
            </div>
        </div>
    </div>
</template>

<style lang="less">
    .selectable-record-card {
        text-align: left;

        .panel {
            margin-bottom: 10px;

            .panel-body {
                padding-top: 7px;
                padding-bottom: 7px;
            }
        }

        .card-content {
            display: flex;

            .record-cover {
                margin-right: 16px;
                width: 70px;
                flex-shrink: 0;
            }

            .record-info {
                width: 100%;
                white-space: normal;
                display: flex;
                flex-direction: row-reverse;
                justify-content: space-between;
            }

            .record-subtitle {
                display: block;
            }

            .card-labels {
                display: flex;
            }
        }
    }
</style>